import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './HeroCarousel.css';

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const setIsAnimating = false;

  const slides = [
    {
      id: 1,
      title: 'Gold Collection',
      subtitle: 'Premium Imitation Jewellery',
      description: 'Exquisite gold-plated pieces crafted with precision for the modern connoisseur',
      image: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=600&h=400&fit=crop',
      tag: '✨ Premium Gold'
    },
    {
      id: 2,
      title: 'Silver Elegance',
      subtitle: 'Timeless Silver Creations',
      description: 'Discover our stunning silver imitation jewellery collection, perfect for every occasion',
      image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=600&h=400&fit=crop',
      tag: '🌟 Sterling Silver'
    },
    {
      id: 3,
      title: 'Royal Heritage',
      subtitle: 'Maharaja & Maharani Collection',
      description: 'Inspired by Indian royalty, our heritage pieces bring the grandeur of tradition',
      image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=600&h=400&fit=crop',
      tag: '👑 Royal Collection'
    },
    {
      id: 4,
      title: 'Bridal Collection',
      subtitle: 'Wedding Special',
      description: 'Complete your bridal look with our stunning jewellery sets for your special day',
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&h=400&fit=crop',
      tag: '💖 Bridal Special'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setIsAnimating(true);
    setCurrentSlide(index);
    setTimeout(() => setIsAnimating(false), 600);
  };

  return (
    <section className="hero-carousel">
      <div className="carousel-header">
        <div className="carousel-title-wrapper">
          <img
            src="/logo192.png"
            alt="श्रीPATI"
            className="carousel-logo"
          />
          <h2 className="carousel-title">
            <span className="devnagari">श्री</span>
            <span className="pati-text">PATI</span>
            <span className="carousel-subtitle-text">Collections</span>
          </h2>
        </div>
        <p className="carousel-tagline">Luxury, Without the occasion. Crafted to Shine Everyday 💅</p>
      </div>

      <div className="carousel-wrapper">
        <div
          className="carousel-track"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="carousel-slide">
              <div className="slide-content">
                <span className="slide-tag">{slide.tag}</span>
                <h3 className="slide-title">{slide.title}</h3>
                <p className="slide-subtitle">{slide.subtitle}</p>
                <p className="slide-description">{slide.description}</p>
                <Link to="/shop" className="slide-btn">
                  Explore Collection <FaArrowRight />
                </Link>
              </div>
              <div className="slide-image">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="slide-img"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="carousel-controls">
        <button className="control-btn" onClick={() => goToSlide((currentSlide - 1 + slides.length) % slides.length)}>
          ‹
        </button>
        <div className="carousel-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentSlide === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
        <button className="control-btn" onClick={() => goToSlide((currentSlide + 1) % slides.length)}>
          ›
        </button>
      </div>
    </section>
  );
};

export default HeroCarousel;